import getActualityUrl, { FeedTypes } from 'url-constructors/getActualityURL';
import { RSAA } from 'redux-api-middleware';
import { Dispatch } from 'redux';
import { TGetRootState, TAsyncDispatchResult } from 'types/shared';

const REQUEST = 'opus/actuality/REQUEST';
const SUCCESS = 'opus/actuality/SUCCESS';
const FAILURE = 'opus/actuality/FAILURE';
const CLEAR = 'opus/actuality/CLEAR';

type ActualityActionTypes = typeof REQUEST | typeof SUCCESS | typeof FAILURE  | typeof CLEAR;

export interface IActualityData {
  endDate: Date;
  name: string;
  startDate: Date;
}

interface IActualityState {
  pending: boolean;
  fulfilled: boolean;
  error: boolean;
  reason: any;
  data: IActualityData[];
  type: FeedTypes;
  filtered: string;
}

interface IActualityAction {
  type: ActualityActionTypes;
  payload: {
    data: IActualityData[];
    type: string;
    filtered: string;
  }
}

const initialState: IActualityState = {
  pending: false,
  fulfilled: false,
  error: false,
  reason: null,
  data: [],
  type: '',
  filtered: '',
};

function reducer(
  state: IActualityState = initialState,
  action: IActualityAction
): IActualityState {
  switch (action.type) {
    case REQUEST: {
      return {
        ...state,
        pending: true,
        fulfilled: false,
        error: false,
        type: action.payload.type,
        filtered: action.payload.filtered,
      };
    }
    case SUCCESS: {
      return {
        ...state,
        pending: false,
        fulfilled: true,
        error: false,
        data: action.payload.data,
        type: action.payload.type,
        filtered: action.payload.filtered,
      };
    }
    case FAILURE: {
      return {
        ...state,
        pending: false,
        fulfilled: false,
        error: true,
        reason: action.payload,
      };
    }
    case CLEAR: {
      return {
        ...state,
        pending: false,
        fulfilled: false,
        error: false,
        type: '',
        filtered: '',
      };
    }
    default: {
      return state;
    }
  }
}

export function resetActuality(): (dispatch: Dispatch) => void {
  return async function (dispatch: Dispatch): Promise<any> {
    dispatch({
      type: CLEAR,
    });
  };
}

function loadActuality(type: FeedTypes, customerFilter: any): TAsyncDispatchResult {
  return async function (
    dispatch: Dispatch,
    getState: TGetRootState
  ): Promise<any> {
    const { actuality } = getState();

    const customerId = customerFilter?.[0] ? `${customerFilter?.[0]}` : '';
    const shouldReloadActualityByType =
      type === 'downloads' || type === 'streaming' || type === 'radio' || type === 'discoveries'
    const shouldReloadActuality = actuality.type !== type ||
      (shouldReloadActualityByType && actuality.filtered !== customerId)

    return await dispatch({
      [RSAA]: {
        bailout: shouldReloadActuality ? false : actuality.pending || actuality.fulfilled,
        types: [
          {
            type: REQUEST,
            payload: {
              type,
              filtered: customerId,
            },
          },
          {
            type: SUCCESS,
            payload: async function payload(
              action: IActualityAction,
              state: IActualityState,
              res: any
            ): Promise<any> {
              const json = await res.json();
              return {
                data: json,
                type,
                filtered: customerId,
              };
            },
          },
          FAILURE,
        ],
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        method: 'GET',
        endpoint: getActualityUrl(type, { customerFilter }),
      },
    });
  };
}

export { loadActuality };
export default reducer;
